{
    "CX_Score_Licences_None": "Aucun",
    "CX_Score_Licences_CXSScore": "Score CX uniquement",
    "CX_Score_Licences_CXSAgent": "Agent CXS",
    "CX_Score_Licences_CXSManager": "Gestionnaire CXS",
    "CX_Score_Agent_Error": "Un agent est requis pour un abonnement {}",
    "NAME": "CXScoreLanguage"
}